import parse from "html-react-parser";
import React from "react";
import { media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import { ButtonBase } from "./Button";
import CloseSVG from "./svgs/x-icon.svg";

const AnnouncementWrapper = styled.div`
  width: 100%;
  min-height: ${pxToRem(57)};
  background-color: ${({ theme }) => theme.gold};
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-bottom: ${pxToRem(10)};

  ${media.tablet} {
    padding: ${pxToRem(10)} ${pxToRem(25)};
  }
`;

const CloseBtn = styled.button`
  ${ButtonBase}
  position: absolute;
  top: ${pxToRem(10)};
  right: ${pxToRem(10)};
  padding: 0;
  color: black;

  &:focus {
    position: absolute; /* redundant because NascarNav styles inject a position: relative on button focus which collapses the UI */
  }
  svg {
    width: ${pxToRem(16)};
    height: ${pxToRem(16)};
  }
`;

export default function AnnouncementBanner({ message, id, handleDismiss }) {
  return (
    <AnnouncementWrapper>
      <CloseBtn onClick={() => handleDismiss(id)}>
        <CloseSVG />
      </CloseBtn>
      {parse(message)}
    </AnnouncementWrapper>
  );
}
